import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";

import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-move.svg';
import { ReactComponent as CloseImg } from '../../../img/ico-prefix-close.svg';
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-stable.svg";
import { ReactComponent as RunningImg } from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as DownImg } from "../../../img/ico-account-idle.svg";

import { ReactComponent as CpuImg } from "../../../img/ico-vpc-list-cpu.svg";
import { ReactComponent as StorageImg } from "../../../img/ico-vpc-list-storage.svg";
import { ReactComponent as MemoryImg } from "../../../img/ico-vpc-list-memory.svg";
import { ReactComponent as MoreImg } from "../../../img/ico-prefix-more-blue.svg";
import { ReactComponent as MoreActiveImg } from "../../../img/ico-prefix-more-white.svg";
import { ReactComponent as SearchNoResultImg } from "../../../img/ico-search-no-result.svg";
import { ReactComponent as ConnectVDIImg } from "../../../img/ico-v-pc-line.svg";

import { AttachedNetworkPort, AttachedSecurityGroup, AttachedVolume } from "./VmDetailContainer";
import { CustomImgBtn } from "../../base/CustomImgBtn";
import { ruleTypes } from "../../virtLogicalResource/securityGroup/SecurityGroupRuleData";
import ListTable from "../../base/table/listTable";
import { actionMenus } from "./VmVolumeData";
import { VmData } from "./VmData";
import { parseLocaleDatetime } from "common/util";



interface VmDetailProps extends ContentContainerProps {
    floatingIpNetworkPortId: string;
    addFloatingIpFunction: Function;
    deleteFloatingIpFunction: Function;
    updateVmFunction: Function;
    updateNetworkPortFunction: Function;
    addSnapshotFunction: Function;
    addVmBackupFunction: Function;
    addNetworkPortFunction: Function;
    addSecurityGroupFunction: Function;
    addVolumeFunction: Function;
    deleteNetworkPortFunction: Function;
    deleteSecurityGroupFunction: Function;
    deleteVolumeFunction: Function;
    connectVdiFunction: Function;

    refreshYn: boolean;
    loadMainDataYn: boolean;
    selectVolumeRow:Function;
    fetchVolumeData:any;
    totalVolumeCount:number;
    volumeHeaders:any;

    detailData: VmData|null;

}

export default function VmDetail(props:VmDetailProps) {
    const { t } = useTranslation();


    return (
        <ContentBox title={t("VM_MGMT_DETAIL_TITLE")} subtitle={t("VM_MGMT_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={{flexDirection: "row"}}>
                <View style={style.topContainer}>
                    <View style={{
                        flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                    }}>
                        <View style={{ flexDirection: "row", alignItems: "center" }}>
                            <Text style={style.dateTitle}>
                                {t("LAST_UPDATE_DATE_TEXT")}
                            </Text>
                            <Text style={style.dateData}>
                                { props.detailData?.update_ts ? parseLocaleDatetime(props.detailData.update_ts) : '-' }
                            </Text>
                        </View>
                        <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                            <Text style={style.dateTitle}>
                                {t("CREATE_DATE_TEXT")}
                            </Text>
                            <Text style={style.dateData}>
                                { props.detailData?.create_ts ? parseLocaleDatetime(props.detailData.create_ts) : '-' }
                            </Text>
                        </View>
                    </View>

                    <View>
                        <View style={{...style.boxContainer, height: 670}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                                <Text style={style.boxContentTitleName}>
                                    { props.detailData?.vm_name ? props.detailData?.vm_name : '-'}
                                </Text>
                                {
                                    props.detailData?.vm_type_code === "SVC" ?
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "center",
                                        marginLeft: "20px", backgroundColor:"#5b9782", borderRadius: 4, width:90, height: 20, fontFamily: FONT.REGULAR, fontSize: 10, color: "#fff"}}>
                                            {t("SERVICE_TEXT")}
                                    </div>
                                    : props.detailData?.vm_type_code === "MGMT" ?
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "center",
                                        marginLeft: "20px", backgroundColor:"#fbefc9", borderRadius: 4, width:90, height: 20, fontFamily: FONT.REGULAR, fontSize: 10, color: "#92782f"}}>
                                            {t("MANAGEMENT_TEXT")}
                                    </div>
                                    : props.detailData?.vm_type_code === "CONTNODE" ?
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "center",
                                        marginLeft: "20px", backgroundColor:"#f5ddd0", borderRadius: 4, width:90, height: 20, fontFamily: FONT.REGULAR, fontSize: 10, color: "#cc7e52"}}>
                                            {t("CONTNODE_TEXT")}
                                    </div>
                                    :
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "center",
                                        marginLeft: "20px", backgroundColor:"#c1c7cc", borderRadius: 4, width:90, height: 20, fontFamily: FONT.REGULAR, fontSize: 10, color: "#fff"}}>
                                            {t("UNKNOWN_TEXT")}
                                    </div>
                                }
                                <div
                                    style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                                    onClick={() => {
                                        props.updateVmFunction();
                                    }}
                                >
                                    <TableEditImg/>
                                    <Text style={{
                                        marginLeft: 2,
                                        fontFamily: FONT.MEDIUM,
                                        fontSize: 12,
                                        color: "#3c5df2"
                                    }}>
                                        {t("INFO_EDIT_TEXT")}
                                    </Text>
                                </div>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 30, height: 54}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("DESCRIPTION_TEXT")}
                                </Text>
                                <Text style={style.boxContentDataText}>
                                    { props.detailData?.vm_description ? props.detailData?.vm_description : '-'}
                                </Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 30}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("VM_POWER_STATUS_TEXT")}
                                </Text>

                                    {
                                        props.detailData?.power_state_code === "RUN" ?
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#333", overflow: "hidden"}}>
                                            <RunningImg />Running
                                        </div>
                                        : props.detailData?.power_state_code === "STDWN"?
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#333", overflow: "hidden"}}>
                                            <DownImg />Down
                                        </div>
                                        :
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#333", overflow: "hidden"}}>
                                            <DownImg />Down
                                        </div>
                                    }
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 30}}>
                                <Text style={style.boxContentHeaderText}>
                                    {t("VM_STATUS_TEXT")}
                                </Text>

                                    {
                                        props.detailData?.vm_status_code === "ACT" ?
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#3a8344", overflow: "hidden"}}>
                                            <ActiveImg />Active
                                        </div>
                                        : props.detailData?.vm_status_code === "SOFF"?
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#8c8c8c", overflow: "hidden"}}>
                                            <DownImg />Down
                                        </div>
                                        : props.detailData?.vm_status_code === "ERR"?
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#e86045", overflow: "hidden"}}>
                                            <DownImg />Error
                                        </div>
                                        : props.detailData?.vm_status_code === "BLD"?
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#edbf1a", overflow: "hidden"}}>
                                            <DownImg />Build
                                        </div>
                                        : props.detailData?.vm_status_code === "UNK"?
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#8c8c8c", overflow: "hidden"}}>
                                            <DownImg />Unknown
                                        </div>
                                        :
                                        <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#8c8c8c", overflow: "hidden"}}>
                                            <DownImg />{props.detailData?.vm_status_code}
                                        </div>
                                    }
                            </View>
                            <View style={style.boxContentDivLine}></View>
                            <View style={{flexDirection: "row"}}>
                                <View style={{width: 490}}>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("AZ_TEXT")}
                                        </Text>
                                        <Text style={style.boxContentDataText}>
                                            { props.detailData?.availability_zone_id ? props.detailData?.availability_zone_id : '-'}
                                        </Text>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("VM_BASE_IMAGE_TEXT")}
                                        </Text>
                                        <Text style={{...style.boxContentDataText}}>
                                            { props.detailData?.vm_image_name ? props.detailData?.vm_image_name : '-'}
                                        </Text>
                                    </View>
                                </View>
                                <View style={{width: 490}}>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("PROJECT_TEXT")}
                                        </Text>
                                        <Text style={{...style.boxContentDataText, color: "#0853fb"}}>
                                            { props.detailData?.project?.project_name ? props.detailData?.project?.project_name : '-'}
                                        </Text>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                        <Text style={style.boxContentHeaderText}>
                                            {t("HOST_NAME_TEXT")}
                                        </Text>
                                        <Text style={{...style.boxContentDataText}}>
                                            { props.detailData?.host_name ? props.detailData?.host_name : '-'}
                                        </Text>
                                    </View>
                                </View>
                            </View>
                            <View style={{height: 160, alignItems: "center", justifyContent: "center"}}>
                                <View style={{width: 760, height: 128, paddingTop: 20, paddingLeft: 30, marginTop: 20,marginBottom: 30, backgroundColor: "#f5f7fa", borderRadius: 10}}>
                                    <View style={style.resourceBox}>
                                        <View style={{flexDirection: "row", alignItems: "center"}}>
                                            <View style={style.imgBox}>
                                                <CpuImg />
                                            </View>
                                            <Text style={style.resourceFixedText}>{t("INSTANCE_CPU_TEXT")}</Text>
                                            <Text style={style.resourceDataText}>{ props.detailData?.vm_type?.vcpu_count ? props.detailData?.vm_type?.vcpu_count : 0}</Text>
                                            <Text style={style.resourceSubText}>cores</Text>
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginLeft: 80}}>
                                            <View style={style.imgBox}>
                                                <StorageImg />
                                            </View>
                                            <Text style={style.resourceFixedText}>{t("INSTANCE_ROOT_DISK_TEXT")}</Text>
                                            <Text style={style.resourceDataText}>{ props.detailData?.root_volume?.volume_size_gb ? props.detailData?.root_volume?.volume_size_gb : 0}</Text>
                                            <Text style={style.resourceSubText}>GB</Text>
                                        </View>
                                    </View>
                                    <View style={{...style.resourceBox, marginTop: 15}}>
                                        <View style={{flexDirection: "row", alignItems: "center"}}>
                                            <View style={style.imgBox}>
                                                <MemoryImg />
                                            </View>
                                            <Text style={style.resourceFixedText}>{t("INSTANCE_MEMORY_TEXT")}</Text>
                                            <Text style={style.resourceDataText}>{ props.detailData?.vm_type?.memory_capacity_mb ? props.detailData?.vm_type?.memory_capacity_mb : 0}</Text>
                                            <Text style={style.resourceSubText}>MB</Text>
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginLeft: 80}}>
                                            <View style={style.imgBox}>
                                                <CpuImg />
                                            </View>
                                            <Text style={{...style.resourceFixedText, width: 100, marginRight: 10}}>{t("KEY_PAIR_NAME_TEXT")}</Text>
                                            <Text style={{...style.resourceDataText, width: 134}}>{ props.detailData?.vm_key_pair_name ? props.detailData?.vm_key_pair_name : ""}</Text>
                                        </View>
                                    </View>
                                </View>
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <CustomImgBtn
                                        size={{width: 136, height: 36}}
                                        text={t("BACKUP_IMEAGE_CREATION_TEXT")}
                                        img={{
                                            active: <MoreActiveImg/>,
                                            inactive: <MoreImg/>,
                                        }}
                                        onPress={() => {props.addVmBackupFunction();}}
                                    />
                                    <View style={{width: 30}} />
                                    <CustomImgBtn
                                        size={{width: 136, height: 36}}
                                        text={t("VM_SNAPSHOST_CREATE_TEXT")}
                                        img={{
                                            active: <MoreActiveImg/>,
                                            inactive: <MoreImg/>,
                                        }}
                                        onPress={() => {props.addSnapshotFunction();}}
                                    />
                                </View>
                            </View>
                        </View>
                        <View style={{...style.boxContainer, minHeight: 250}}>
                            <View style={{flexDirection: "row", alignItems: "flex-end", marginBottom: 30}}>
                                <Text style={{...style.boxContentTitle, width: 120, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                    {t("IP_ADDRESS_TEXT")}
                                </Text>
                                <Text style={{...style.boxContentTitleDescription}}>
                                    {t("MESSAGE_VM_DETAIL_IP_ADDRESS_TITLE_DESCRIPTION_MESSAGE")}
                                </Text>
                                <div
                                    style={{
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        width: 95, height: 24,
                                        marginLeft: "auto",
                                        borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                        backgroundColor: "#fff",
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: "#333",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {props.detailData?.network_ports && props.detailData?.network_ports.filter((port) => {
                                        if(port.floating_ip?.floating_ip_id) {
                                            return true;
                                        }
                                    }).length > 0 ? props.deleteFloatingIpFunction() : props.addFloatingIpFunction()}}
                                >
                                    {props.detailData?.network_ports && props.detailData?.network_ports.filter((port) => {
                                        if(port.floating_ip?.floating_ip_id) {
                                            return true;
                                        }
                                    }).length > 0 ? t("VM_FLOATING_IP_DELETE_TEXT") : t("VM_FLOATING_IP_ADD_TEXT")}
                                    <RedirImg style={{marginLeft: 3}}/>
                                </div>
                                <div
                                    style={{
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        width: 95, height: 24,
                                        marginLeft: 10,
                                        borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                        backgroundColor: "#fff",
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: "#333",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {props.addNetworkPortFunction()}}
                                >
                                    {t("VNIC_ADD_TEXT")}
                                    <RedirImg style={{marginLeft: 3}}/>
                                </div>
                            </View>
                            {
                                props.detailData?.network_ports && props.detailData?.network_ports?.length > 0 ? props.detailData?.network_ports.map((item, index) => {
                                    return (
                                        <View key={item.network_port_id} style={{flexDirection: "row", alignItems: "center"}}>
                                            <View style={style.innerItemContainer}>
                                                {
                                                    item.up_yn === true ? <StatusStableImg /> : <StatusBlockImg />
                                                }
                                                <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                                    {
                                                        item.network_port_name
                                                    }
                                                </Text>
                                                <View style={style.innerDataContainer}>
                                                    <Text style={style.innerItemBlueText}>
                                                        {item.network.network_name}
                                                    </Text>
                                                    <View style={style.innerColumnDivLine}></View>
                                                    <Text style={{...style.boxContentDataText, marginLeft:9 }}>{"MAC"}</Text>
                                                    <Text style={{...style.innerDataGreenText, marginLeft:5 }}>{item.mac_address}</Text>
                                                    <Text style={{...style.boxContentDataText, marginLeft:5 }}>{"IP"}</Text>
                                                    <Text style={{...style.innerDataGreenText, marginLeft:5 }}>{item.fixed_ip_address}</Text>
                                                </View>
                                                <View style={{...style.innerDataContainer, marginLeft: 5, width: 200}}>
                                                    <Text style={style.innerItemText}>
                                                        {"Floating IP"}
                                                    </Text>
                                                    <Text style={{...style.innerDataGreenText, marginLeft:5 }}>{item.floating_ip?.floating_ip_address ? item.floating_ip.floating_ip_address : t("NOT_CONNECTED_TEXT")}</Text>
                                                </View>
                                                <div
                                                    style={{
                                                        display: "flex", alignItems: "center", justifyContent: "center",
                                                        width: 65, height: 24,
                                                        marginLeft: "auto",
                                                        borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                                        backgroundColor: "#fff",
                                                        fontFamily: FONT.REGULAR,
                                                        fontSize: 12,
                                                        color: "#333",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {props.updateNetworkPortFunction(item)}}
                                                >
                                                    {t("EDIT_TEXT")}
                                                    <RedirImg style={{marginLeft: 3}}/>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex", alignItems: "center", justifyContent: "center",
                                                        width: 65, height: 24,
                                                        marginLeft: 10,
                                                        borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                                        backgroundColor: "#fff",
                                                        fontFamily: FONT.REGULAR,
                                                        fontSize: 12,
                                                        color: "#333",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {props.deleteNetworkPortFunction(item)}}
                                                >
                                                    {t("DELETE_TEXT")}
                                                    <CloseImg style={{marginLeft: 3}}/>
                                                </div>
                                            </View>
                                        </View>
                                        )
                                    })
                                :
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <View key={99} style={{...style.innerItemContainer, justifyContent:"center"}}>
                                        <SearchNoResultImg style={style.innerItemEmptyImg}/>
                                        <Text style={style.innerItemEmtpyText}>
                                            {t("SEARCH_NO_RESULT_MAIN_TEXT")}
                                        </Text>
                                    </View>
                                </View>
                            }
                        </View>

                        <View style={{...style.boxContainer, minHeight: 250}}>
                            <View style={{flexDirection: "row", alignItems: "flex-end", marginBottom: 30}}>
                                <Text style={{...style.boxContentTitle, width: 120, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                    {t("SECURITY_GROUP_TEXT")}
                                </Text>
                                <Text style={{...style.boxContentTitleDescription}}>
                                    {t("MESSAGE_VM_DETAIL_SECURITY_GROUP_TITLE_DESCRIPTION_MESSAGE")}
                                </Text>
                                <div
                                    style={{
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        width: 120, height: 24,
                                        marginLeft: "auto",
                                        borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                        backgroundColor: "#fff",
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: "#333",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {props.addSecurityGroupFunction()}}
                                >
                                    {t("SECURITY_GROUP_ADD_TEXT")}
                                    <RedirImg style={{marginLeft: 3}}/>
                                </div>
                            </View>
                            {
                                props.detailData?.security_groups && props.detailData?.security_groups?.length > 0 ? props.detailData?.security_groups?.map((item, index) => {
                                return (
                                    <View key={item.security_group_id} style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{...style.innerItemContainer, alignItems: "flex-start"}}>
                                            <View>
                                                <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                                    {
                                                        item.security_group_name
                                                    }
                                                </Text>
                                            </View>
                                            <View>
                                            {
                                                item.security_group_rules && item.security_group_rules?.length > 0 ? item.security_group_rules?.map((rule, index) => {
                                                    return (
                                                        <View key={rule.security_group_rule_id} style={{...style.innerDataContainer, width: 650, marginBottom: 4}}>
                                                            <Text style={style.innerItemText}>
                                                                {
                                                                    rule.direction_type_code === "IN" ? "Inbound" : "Outbound"
                                                                }
                                                            </Text>
                                                            <Text style={style.innerItemText}>
                                                                {
                                                                    (()=>{
                                                                        if(!rule.security_group_rule_type_code || rule.security_group_rule_type_code === "ALL") {
                                                                            return t("TOTAL_TEXT");
                                                                        }
                                                                        for(let ruleType of ruleTypes) {
                                                                            if(ruleType.value === rule.security_group_rule_type_code) {
                                                                                return ruleType.label;
                                                                            }
                                                                        }
                                                                    })()
                                                                }
                                                            </Text>
                                                            <Text style={style.innerItemText}>
                                                                {
                                                                    rule.open_port_type_code === "SINGLE" ? t("SINGLE_PORT_TEXT")
                                                                    : rule.open_port_type_code === "MULTI" ? t("MULTI_PORT_TEXT")
                                                                    : t("ALL_PORT_TEXT")
                                                                }
                                                            </Text>
                                                            <Text style={{...style.innerItemBlueText, width: 100, textAlign:"center"}}>
                                                                {
                                                                    rule.open_port_type_code === "SINGLE" ? rule.min_port
                                                                    : rule.open_port_type_code === "MULTI" ? rule.min_port.toString() + '-' + rule.max_port.toString()
                                                                    : "*"
                                                                }
                                                            </Text>
                                                            <Text style={{...style.innerItemText, width: 160}}>
                                                                {
                                                                    rule.remote_type_code === "CIDR" ? rule.remote_cidr ? "CIDR: " + rule.remote_cidr : "Remote ALL: 0.0.0.0/0"
                                                                    : rule.remote_security_group_name ? t("SECURITY_GROUP_TEXT") + ": " + rule.remote_security_group_name
                                                                    : "Remote ALL: 0.0.0.0/0"
                                                                }
                                                            </Text>
                                                        </View>
                                                    );
                                                })
                                                :
                                                <View style={{...style.innerDataContainer, width: 650, marginBottom: 4}}>
                                                    <Text style={style.innerItemEmtpyText}>
                                                        {t("EMPTY_TEXT")}
                                                    </Text>
                                                </View>
                                            }
                                            </View>
                                            <div
                                                style={{
                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                    width: 65, height: 24,
                                                    marginLeft: "auto",
                                                    borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                                    backgroundColor: "#fff",
                                                    fontFamily: FONT.REGULAR,
                                                    fontSize: 12,
                                                    color: "#333",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {props.deleteSecurityGroupFunction(item)}}
                                            >
                                                {t("DELETE_TEXT")}
                                                <CloseImg style={{marginLeft: 3}}/>
                                            </div>
                                        </View>
                                    </View>
                                    )
                                })
                                :
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <View key={99} style={{...style.innerItemContainer, justifyContent:"center"}}>
                                        <SearchNoResultImg style={style.innerItemEmptyImg}/>
                                        <Text style={style.innerItemEmtpyText}>
                                            {t("SEARCH_NO_RESULT_MAIN_TEXT")}
                                        </Text>
                                    </View>
                                </View>
                            }
                        </View>
                        <View style={{...style.boxContainer, minHeight: 250}}>
                            <View style={{flexDirection: "row", alignItems: "flex-end", marginBottom: 30}}>
                                <Text style={{...style.boxContentTitle, width: 120, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                    {t("CONNECTED_VOLUME_TEXT")}
                                </Text>
                                <Text style={{...style.boxContentTitleDescription}}>
                                    {t("MESSAGE_VM_DETAIL_VOLUME_TITLE_DESCRIPTION_MESSAGE")}
                                </Text>
                            </View>
                            <View style={{marginTop: 24}}>
                            <ListTable
                                id={"connectedVolume"}
                                actionMenus={actionMenus}
                                actionMenuClickCb=
                                {(code)=>{code === "VOLUME_ADD" ? props.addVolumeFunction(): props.deleteVolumeFunction()}}
                                searchBarYn={false}
                                pageYn={true}
                                rowCheckYn={true}
                                rowCheckCb={props.selectVolumeRow}
                                fetchDataCb={props.fetchVolumeData}
                                pageCount={1}
                                pageSize={20}
                                tableHeaders={props.volumeHeaders}
                                tableData={props.detailData?.volumes ? props.detailData?.volumes : []}
                                totalItemCount={props.detailData?.volumes.length || 0}
                                detailYn={true}
                                refreshYn={props.refreshYn}
                                canLoadYn={true}
                                minHeight={230}
                            />
                        </View>
                        </View>
                    </View>
                </View>
                <View style={{width: 200, marginTop: 40}}>
                    
                    <div
                        style={{display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                        marginLeft: "20px", backgroundColor:"#16c780", borderRadius: 4, width:100, height: 140}}
                        onClick={(e)=>{props.connectVdiFunction()}}
                    >
                            <View style={{alignItems: "center", justifyContent:"center"}}>
                            <ConnectVDIImg />
                            <View style={{height: 5}} />
                            <Text style={{fontFamily: FONT.REGULAR, fontSize: 10, color: "#fff"}}>
                                가상머신 연결
                            </Text>
                            </View>
                    </div>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1090,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitleName: {
        fontFamily: FONT.BOLD,
        fontSize: 20,
        color: "#494a4d"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentTitleDescription: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    boxContentHeaderText: {
        width: 130,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentDivLine: {
        height: 1,
        border: "solid 0.5px #eee", marginBottom: 30
    },
    innerItemEmtpyText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#4d5367"
    },
    innerItemEmptyImg: {
        width: 50,
        height: 50,
        marginRight: 30,
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {
        flexDirection: "row",
        width: 760, minHeight: 32,
    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 120,
        marginRight: 45,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        width: 50,
        fontFamily: FONT.BOLD,
        textAlign: "right",
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        width: 40,
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    innerItemContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        marginBottom: 30, marginTop: 10, minHeight: 80,
        borderRadius: 10,
        borderStyle: "solid",
        borderWidth: 0.8,
        borderColor: "#d2d5d9",
        paddingLeft: 30,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 20
    },
    innerItemName: {
        marginLeft: 10,
        width: 130,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerDataContainer: {
        marginLeft: 30,
        flexDirection: "row",
        alignItems: "center",
        width: 400,
        height: 36,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        paddingLeft: 20
    },
    innerItemBlueText: {
        width: 120,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#0853fb",
        overflow: "hidden",
    },
    innerItemText: {
        width: 80,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerColumnDivLine: {
        height: 18,
        borderColor: "#d2d5d9",
        borderStyle: "solid",
        borderWidth: 0.8
    },
    innerDataGreenText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#3a8344"
    },
});
